import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import type { FieldFormProps } from '@helpcenter/field-types';
import type { WrappedComponentProps } from 'react-intl-next';
import { injectIntl } from 'react-intl-next';
import { FieldBase } from 'view/common/fields/field-base';
import { RadioGroup as AkRadioGroup } from '@atlaskit/radio';
import { token } from '@atlaskit/tokens';
import i18n from './messages';

interface Item {
    label: string;
    name: string;
    value: string;
}

interface Props extends FieldFormProps<string> {
    items?: Item[];
    defaultValue?: string;
}

const NONE_OPTION_VALUE = '-1';

class RadioGroup extends React.PureComponent<Props & WrappedComponentProps> {
    onChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        if (this.props.onChange) {
            this.props.onChange(this.props.id, e.target.value);
        }
    };

    render() {
        const { required, label, id, description, defaultValue, errorMessage, disabled, intl, items = [] } = this.props;

        const radioItems = items.map((item) => {
            return {
                label: item.label,
                name: item.name,
                value: item.value,
                isDisabled: disabled,
            };
        });

        if (!required) {
            radioItems.push({
                label: intl.formatMessage(i18n.noneOptionLabel),
                name: id,
                value: NONE_OPTION_VALUE,
                isDisabled: disabled,
            });
        }

        return (
            <FieldBase
                htmlFor={id}
                noLabel={false}
                required={required}
                description={description}
                label={label}
                labelId={`label-${id}`}
                errorMessage={errorMessage}
            >
                <RadioGroupWrapper>
                    <AkRadioGroup
                        isRequired={required}
                        options={radioItems}
                        onChange={this.onChange}
                        defaultValue={defaultValue}
                        aria-labelledby={`label-${id}`}
                        aria-describedby={`${id}-field-description`}
                    />
                </RadioGroupWrapper>
            </FieldBase>
        );
    }
}

export default injectIntl(RadioGroup);

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const RadioGroupWrapper = styled.div`
    padding: ${token('space.075', '6px')};
`;
